/**
 * 入驻状态
 * 
 */
export const enterStatus = {
    UNCOMMITTED:'0',//未提交
    TOAUDIT:'10',//发起申请（草稿状态）
    AUDITING:'20',//审核中 (申请提交（待审）)
    REFUSE_MODIFY:'11',//审核驳回—待修改
    REFUSE_TRANSITORY:'00',//审核驳回—不合作
    NOBIND:'30',//未绑定w商家编码
    BIND:'2',//已绑定W商家编码(已入驻)
}
/**
 * 入驻类型
 *  1:POP商家 2:全球购 3:自营合作 4:线下联营
 *  已废弃 TODO:
 */
export const enterType = {
    POP:'1',
    GLOBALBUY:'2',
    PROPRIETARY:'3',
    OFFLINE:'4',
    EDU:'5,6',
    YUER: '5',
    CZJ: '6',
    HANDPICKLIVE:'7'//精选生活
}


/**
 * 商家类型
 * 1:联营合作（商家线上自主开店） 2:全球购合作 3:线下门店联营（线下门店开店） 4:自营供货商（供货给孩子王）  5:育儿平台（育儿服务） 6:成长加（成长服务)  8:非供应商家  9: 孩慧营商家
 */
export const buzzType = {
    POP:1,
    GLOBALBUY:2,
    BRANDMERCHANT:3,
    PROPRIETARY:4,
    YUER:5,
    CZJ:6,
    ADVERTISER: 9,
}

export const buzzTypeList = [{
    type:buzzType.POP,
    name:'联营合作（商家线上自主开店）'
},{
    type:buzzType.GLOBALBUY,
    name:'全球购合作'
},{
    type:buzzType.BRANDMERCHANT,
    name:'线下门店联营（线下门店开店）'
},{
    type:buzzType.PROPRIETARY,
    name:'自营供货商（含供应商&自营品牌商）'
},{
    type:buzzType.YUER,
    name:'育儿平台（育儿服务）'
},{
    type:buzzType.CZJ,
    name:'成长加（成长服务）'
}, {
    type: buzzType.ADVERTISER,
    name: '孩慧营商家',
}]
